'use client'

import { Img } from 'components/basic/Img'
import { Pod4Hero } from 'components/Phantom/_sections/Pod4Hero'
import { Pod4HeroProps } from 'components/Phantom/_sections/Pod4Hero/types'
import { ScrollSequenceStatic } from 'components/Phantom/_sections/ScrollSequenceStatic'
import { Pod4FAQ } from 'components/Pod4FAQ'
import { Pod4FAQProps } from 'components/Pod4FAQ/types'
import { Pod4ShopComparison } from 'components/Pod4ShopComparison'
import { TruemedBenefits } from 'components/TruemedBenefits'
import styles from 'components/TruemedBenefits/TruemedBenefits.module.scss'
import { TruemedHIW } from 'components/TruemedHIW'
import { FC } from 'react'

export const homepageProps: Pod4HeroProps = {
	header: 'Save an average of 30% with FSA/HSA',
	maxHeaderWidth: '15ch',
	content: (
		<Img
			src={'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/trumed_hero_img.png'}
			sources={[
				{
					src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/trumed_mobile_hero.jpg',
					mediaQuery: '(max-width: 1024px)',
				},
			]}
			objectFit={'cover'}
			alt={'The Pod 4 sitting on ice'}
		/>
	),
	cta: {
		text: 'Shop now',
		href: '/product/pod-cover/',
	},
	ctaFooterContent: (
		<div className={styles.cta_footer}>
			HSA/FSA-eligible with{' '}
			<Img
				className={styles.truemed_big_small}
				src={'https://d115sb6i1ixllw.cloudfront.net/assets/trumed_white.svg'}
				alt={''}
			/>
		</div>
	),
}

export const TruemedLP: FC<{
	faqData: Pod4FAQProps
}> = (props) => {
	const { faqData } = props
	return (
		<>
			<Pod4Hero {...homepageProps} />
			<TruemedBenefits />
			<TruemedHIW />
			<Pod4ShopComparison showTruemed={true} />

			<Pod4FAQ {...faqData} />
			<ScrollSequenceStatic />
		</>
	)
}
